export interface TableWidthOptions {
  windowWidth: number;
  sidebarOpen: boolean;
  leftFilterWidth?: number;
  minWidth?: number;
}

const SIDEBAR_OPEN_WIDTH = 220;
const HORIZONTAL_PADDING = 32;
const EXTRA_OFFSET = 16;
const DEFAULT_MIN_WIDTH = 300;

export const calculateTableWidth = ({
  windowWidth,
  sidebarOpen,
  leftFilterWidth = 0,
  minWidth = DEFAULT_MIN_WIDTH,
}: TableWidthOptions): number => {
  const sidebarWidth = sidebarOpen ? SIDEBAR_OPEN_WIDTH : 0;
  const availableWidth = windowWidth - sidebarWidth - leftFilterWidth - HORIZONTAL_PADDING - EXTRA_OFFSET;
  return Math.max(availableWidth, minWidth);
};
